import React from "react";

function Order_description({ handleChangeData }) {
  const handleChange = (e) => {
    //validation data

    //if valid
    const order_description = e.target.value;
    handleChangeData({ order_description });
  };
  return (
    <div className="form-item">
      <div className="right">
        <label htmlFor="order_description">
          <i className="far fa-comment-alt"></i>
          توضیحات سفارش
        </label>
      </div>
      <div className="left">
        <textarea
          onChange={handleChange}
          name="order_description"
          id="order_description"
          placeholder="اگر سفارشتون نیاز به توضیح داره برامون بنویسید."
          rows="3"
        ></textarea>
      </div>
    </div>
  );
}

export default Order_description;
